import { __assign, __rest } from "tslib";
import React from 'react';
import { Svg } from '@marvelapp/ui';
export default function LayerRounded(_a) {
    var props = __rest(_a, []);
    return (React.createElement(Svg, __assign({ display: "block", height: "24px", viewBox: "0 0 24 24", width: "24px" }, props),
        React.createElement("rect", { height: "11", opacity: "0.22", rx: "1.68", width: "11", x: "6.5", y: "6.5" }),
        React.createElement("path", { d: "M15.82,7A1.18,1.18,0,0,1,17,8.18v7.64A1.18,1.18,0,0,1,15.82,17H8.18A1.18,1.18,0,0,1,7,15.82V8.18A1.18,1.18,0,0,1,8.18,7h7.64m0-1H8.18A2.19,2.19,0,0,0,6,8.18v7.64A2.19,2.19,0,0,0,8.18,18h7.64A2.19,2.19,0,0,0,18,15.82V8.18A2.19,2.19,0,0,0,15.82,6Z" })));
}
